export function formatThoughtForSecondsLabel(thinkingStartedAtMs, endedAtMs = Date.now()) {
  const elapsed = Math.max(0, endedAtMs - thinkingStartedAtMs)
  return `Thought for ${Math.ceil(elapsed / 1000)}s`
}

export function resolveThoughtSummaryWithDuration(prevMsg, apiMeta, endedAtMs = Date.now()) {
  if (apiMeta?.thoughtSummary?.trim()) return apiMeta.thoughtSummary.trim()
  const start =
    typeof prevMsg?.thinkingStartedAt === 'number'
      ? prevMsg.thinkingStartedAt
      : typeof prevMsg?.createdAt === 'number'
        ? prevMsg.createdAt
        : endedAtMs
  return formatThoughtForSecondsLabel(start, endedAtMs)
}
